import React from 'react'
import Image from '../../../images/buyerpolicies/Amendments.png'

const Amendments = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Amendments</h2>
            <p>It is also the right of KAAY to change the terms of use whenever needed. Whenever you make an order at KAAY, that order will follow and observe the normal conditions described at that time. Make sure you visit the web page regularly to keep updated about the changed policies and procedures.</p>
        </div>
      </div>
    </div>
  )
}

export default Amendments
